<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="card p-5">


          <div class="row mt-4">
            <div class="col-12">
              <h3>Dashboard</h3>
              <p>Dashboard with rotating statistics</p>
              <router-link
                           class="btn btn-info btn-sm"
                           v-b-tooltip.hover
                           title="dashboard"
                           :to="{
                            name: 'dashboard',
                          }">
                Dashboard
              </router-link>
              <hr />
            </div>
          </div>


          <div class="row mt-4">
            <div class="col-12">
              <h3>Current Jobs</h3>
              <p>Current open jobs and jobs closed / Cancelled in the past 30 days</p>
              <a
                 :href="`/reports/jobs?cid=${company_id}&report=current`"
                 class="btn btn-sm btn-primary">
                Export Excel
              </a>
              <hr />
            </div>
          </div>


          <div class="row mt-4">
            <div class="col-12">
              <h3>Jobs</h3>
              <p>All jobs created at in date range</p>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-md-4">
                  <label for="from">From</label>
                  <b-form-datepicker
                                     id="from"
                                     v-model="from"
                                     class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-md-4">
                  <label for="to">To</label>
                  <b-form-datepicker
                                     id="to"
                                     v-model="to"
                                     class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-md-4">
                  <p class="font-weight-bold">Max 3 year range</p>

                  <button
                          @click="jobsInRange"
                          class="btn btn-sm btn-primary ml-2">
                    Excel
                  </button>
                </div>
              </div>
              <hr>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12">
              <h3>Shipping Summary</h3>
              <p>Current jobs in transit, and awaiting shipping</p>
              <a
                 :href="`/reports/shipping?cid=${company_id}`"
                 class="btn btn-sm btn-primary">
                Export Excel
              </a>
              <hr />
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12">
              <h3>Partners Summary</h3>
              <p>List of partners with balances</p>
              <a
                 :href="`/reports/partners-outstanding-balances?cid=${company_id}`"
                 class="btn btn-sm btn-primary">
                Export Excel
              </a>
              <hr />
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12">
              <h3>Clients Summary</h3>
              <p>List of clients only with an outstanding balance</p>
              <a
                 :href="`/reports/clients-outstanding-balances?cid=${company_id}`"
                 class="btn btn-sm btn-primary">
                Export Excel
              </a>

              <hr>
            </div>

          </div>


          <div class="row mt-4">
            <div class="col-12">
              <h3>Suppliers Summary</h3>
              <p>List of suppliers outstanding balance</p>
              <a
                 :href="`/reports/suppliers-outstanding-balances?cid=${company_id}`"
                 class="btn btn-sm btn-primary">
                Export Excel
              </a>

              <hr>
            </div>

          </div>


          <div class="row mt-4">
            <div class="col-12">
              <h3>Parts</h3>
              <p>List of parts with procing and stock level</p>
              <a
                 :href="`/reports/parts?cid=${company_id}`"
                 class="btn btn-sm btn-primary">
                Export Excel
              </a>

              <hr>
            </div>

          </div>



          <div class="row mt-4">
            <div class="col-12">
              <h3>Technician Statistics</h3>
              <p>Technician performance report</p>

            </div>

            <div class="col-12">
              <div class="row">
                <div class="col-md-4">
                  <label for="from">From</label>
                  <b-form-datepicker
                                     id="from"
                                     v-model="from"
                                     class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-md-4">
                  <label for="to">To</label>
                  <b-form-datepicker
                                     id="to"
                                     v-model="to"
                                     class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-md-4">
                  <p class="font-weight-bold">Max 3 year range</p>

                  <button
                          @click="techniciansInRange"
                          class="btn btn-sm btn-primary ml-2">
                    Excel
                  </button>
                </div>
              </div>
              <hr>
            </div>
          </div>



          <div class="row mt-4">
            <div class="col-12">
              <h3>Accounts Receivable Transactions Lists</h3>
              <p>Client and Partner information report for period</p>

            </div>

            <div class="col-12">
              <div class="row">
                <div class="col-md-4">
                  <label for="from">From</label>
                  <b-form-datepicker
                                     id="from"
                                     v-model="from"
                                     class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-md-4">
                  <label for="to">To</label>
                  <b-form-datepicker
                                     id="to"
                                     v-model="to"
                                     class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-md-4">
                  <label for="to">Report</label>
                  <b-form-select v-model="accountList.report">
                    <b-form-select-option
                      v-for="pr in ['Invoices','Payments','Credits','Debits']"
                      :value="pr"
                      :key="pr"
                      >{{ pr }}</b-form-select-option
                    >
                  </b-form-select>
                </div>
                <div class="col-md-12 text-right">
                  <button
                          @click="accountsReceivableTransactionsInRange('xlsx')"
                          class="btn btn-sm btn-primary ml-2">
                    Excel
                  </button>
                  <button
                          @click="accountsReceivableTransactionsInRange('pdf')"
                          class="btn btn-sm btn-info ml-1">
                    PDF
                  </button>
                </div>
              </div>
              <hr>
            </div>
          </div>


          <div class="row mt-4">
            <div class="col-12">
              <h3>Financials</h3>
              <p>Financial report for period</p>

            </div>

            <div class="col-12">
              <div class="row">
                <div class="col-md-4">
                  <label for="from">From</label>
                  <b-form-datepicker
                                     id="from"
                                     v-model="from"
                                     class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-md-4">
                  <label for="to">To</label>
                  <b-form-datepicker
                                     id="to"
                                     v-model="to"
                                     class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-md-4">
                  <p class="font-weight-bold">Max 3 year range</p>

                  <button
                          @click="financialInRange"
                          class="btn btn-sm btn-primary ml-2">
                    Excel
                  </button>
                </div>
              </div>
              <hr>
            </div>

            <div class="col-12">
              <div class="row">
                <div class="col-md-4">
                  <div class="card box-shadow h-100">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h1
                              class="font-weight-bold text-success text-monospace">
                            {{ clientsOutstanding }}
                          </h1>
                        </div>

                      </div>

                      <p>Clients Outstanding <br> Receivable</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card box-shadow h-100">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h1
                              class="font-weight-bold text-success text-monospace">
                            {{ partnersOutstanding }}
                          </h1>
                        </div>

                      </div>

                      <p>Partners Outstanding <br> Receivable</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card box-shadow h-100">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h1
                              class="font-weight-bold text-danger text-monospace">
                            {{ suppliersOutstanding }}
                          </h1>
                        </div>

                      </div>

                      <p>Supplier Outstanding <br> Payable</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reportRepo from '@/api/repos/reportRepo';

export default {
  data() {
    return {
      from: this.moment().subtract(3, 'months').format("YYYY-MM-DD"),
      to: this.moment().format("YYYY-MM-DD"),
      company_id: localStorage.getItem("current_company_id"),
      loading: false,
      clientsOutstanding: 0,
      partnersOutstanding: 0,
      suppliersOutstanding: 0,
      accountList:{
        report:'Invoices'
      }
    };
  },

  mounted() {
    this.getBalances()
  },

  methods: {
    async getBalances() {
      let { data } = await reportRepo.outstandingBalances();
      data.data.forEach(x => {
        if (x.type == 'App\\Client') {
          this.clientsOutstanding = x.total
        }
      });
      data.data.forEach(x => {
        if (x.type == 'App\\Partner') {
          this.partnersOutstanding = x.total
        }
      });
      data.data.forEach(x => {
        if (x.type == 'App\\Supplier') {
          this.suppliersOutstanding = x.total
        }
      });
    },

    async jobsInRange() {

      //from is not greater
      if (this.moment(this.from).isAfter(this.moment(this.to))) {
        this.$root.$bvToast.toast("From can not be after to", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      //not more then a year
      if (this.moment(this.to).diff(this.moment(this.from), 'days') > 1098) {
        this.$root.$bvToast.toast("Range can not be greater than 3 year", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      window.open(`/reports/jobs?cid=${this.company_id}&report=range&from=${this.from}&to=${this.to}`)

    },

    async techniciansInRange() {

      //from is not greate
      if (this.moment(this.from).isAfter(this.moment(this.to))) {
        this.$root.$bvToast.toast("From can not be after to", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      //not more then a year
      if (this.moment(this.to).diff(this.moment(this.from), 'days') > 1098) {
        this.$root.$bvToast.toast("Range can not be greater than 3 year", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      window.open(`/reports/technicians?cid=${this.company_id}&report=range&from=${this.from}&to=${this.to}`)

    },
    async financialInRange() {

      //from is not greater
      if (this.moment(this.from).isAfter(this.moment(this.to))) {
        this.$root.$bvToast.toast("From can not be after to", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      //not more then a year
      if (this.moment(this.to).diff(this.moment(this.from), 'days') > 1098) {
        this.$root.$bvToast.toast("Range can not be greater than 3 year", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      window.open(`/reports/financial?cid=${this.company_id}&report=range&from=${this.from}&to=${this.to}`)

    },

    async accountsReceivableTransactionsInRange(format){

       //from is not greater
       if (this.moment(this.from).isAfter(this.moment(this.to))) {
        this.$root.$bvToast.toast("From can not be after to", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      //not more then a year
      if (this.moment(this.to).diff(this.moment(this.from), 'days') > 1098) {
        this.$root.$bvToast.toast("Range can not be greater than 3 year", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return;
      }

      window.open(`/reports/accounts-receivable-transaction-list/${this.accountList.report.toLowerCase()}?cid=${this.company_id}&report=range&from=${this.from}&to=${this.to}&reportFormat=${format}`)

    }
  },
};
</script>

<style></style>